/**
 * Draft-safe HOSHOKU wardrobe media layer.
 *
 * Shopify's original product media remains untouched and available as the
 * secondary gallery images. This layer swaps only the leading visual used by
 * product cards, the product gallery and the sticky add-to-cart bar.
 */
(function () {
  const config = document.getElementById('UndrProductMediaOverrides');
  if (!config) return;

  const overrides = {
    'u-002-seek-reality-oversized-shirt': { source: config.dataset.seekReality, cardMode: 'secondary' },
    'u-002-hoshoku-shirt-1': { source: config.dataset.hoshokuShirt, cardMode: 'secondary' },
    'u-002-seek-u-shorts': { source: config.dataset.seekUShorts, cardMode: 'primary' },
  };

  function setImage(image, source) {
    if (!(image instanceof HTMLImageElement) || !source || image.dataset.undrMediaOverride === source) return;

    image.src = source;
    image.srcset = source;
    image.removeAttribute('sizes');
    image.dataset.undrMediaOverride = source;
  }

  function productHandleFromUrl(url) {
    try {
      const match = new URL(url, window.location.origin).pathname.match(/^\/products\/([^/]+)/);
      return match?.[1] || '';
    } catch (_error) {
      return '';
    }
  }

  function replaceCardMedia(root) {
    root.querySelectorAll?.('product-card').forEach((card) => {
      const link = card.querySelector('a[href*="/products/"]');
      const override = overrides[productHandleFromUrl(link?.href || '')];
      if (!override?.source) return;

      const gallery = card.querySelector('.card-gallery');
      const media = gallery ? [...gallery.querySelectorAll('img')] : [];

      // Product cards stay garment-first. Horizon's native hover preview moves
      // to slide two, which becomes the HOSHOKU-worn editorial view.
      const targetIndex = override.cardMode === 'primary' ? 0 : 1;
      setImage(media[targetIndex], override.source);
    });
  }

  function replaceProductMedia(root) {
    const handle = productHandleFromUrl(window.location.href);
    const override = overrides[handle];
    if (!override?.source) return;

    root.querySelectorAll?.('.sticky-add-to-cart__image img').forEach((image) => setImage(image, override.source));

    root.querySelectorAll?.('media-gallery').forEach((gallery) => {
      const firstMedia = gallery.querySelector('.product-media-container img');
      setImage(firstMedia, override.source);
    });
  }

  function applyOverrides(root = document) {
    replaceCardMedia(root);
    replaceProductMedia(root);
  }

  applyOverrides();

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node instanceof Element) applyOverrides(node);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
